import React from 'react';
import Text from '@amzn/meridian/text';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  ConnectPhoneRecord,
  ContactListeningQueryTypeOption,
} from '../../../api/ContactListening/schema';
import AudioPlayer from './AudioPlayer';
import {
  CLClickstream,
  CLClickstreamWithMediaLegInfo,
} from '../utils/ContactListeningHelpers';
import CoachingEmptyState from '../../../Assets/coachingEmptyState.png';

export interface SingleRecordingProps {
  recording: ConnectPhoneRecord | undefined;
  contactListeningParams: any;
  isEscalation: boolean;
  agentLogin: string;
  CLClickstream: CLClickstream;
}

export const SingleRecording: React.FC<SingleRecordingProps> = ({
  recording,
  contactListeningParams,
  isEscalation,
  agentLogin,
  CLClickstream,
}) => {
  const intl = useIntl();
  if (!recording?.callRecordingPart?.base64) {
    return (
      <Column alignmentHorizontal='center' alignmentVertical='center'>
        <div>
          <img src={CoachingEmptyState} alt='no contacts' />
        </div>
        <Text>
          <FormattedMessage
            id='cs_perfportal_contact_listening_no_call_recording'
            defaultMessage='There is no call recording to display here at the moment.'
          />
        </Text>
      </Column>
    );
  }

  const firstBase64 = recording.callRecordingPart?.base64?.toString();

  const nextBlobParams = {
    ...contactListeningParams,
    queryType: {
      queryTypeOption: isEscalation
        ? ContactListeningQueryTypeOption.DART_CONNECT_PART
        : ContactListeningQueryTypeOption.CONNECT_PART,
      part: recording.callRecordingPart?.nextPart,
      connectid: recording.connectContactId,
    },
  };

  const CLClickstreamWithMediaLegInfo: CLClickstreamWithMediaLegInfo = {
    ...CLClickstream,
    connectContactId: recording.connectContactId,
  };

  return (
    <Column>
      <AudioPlayer
        firstBase64={firstBase64}
        nextBlobParams={nextBlobParams}
        id={recording.connectContactId?.toString()}
        CLClickstreamWithMediaLegInfo={CLClickstreamWithMediaLegInfo}
      />
      <Box type='fill' spacingInset='500'>
        <Column>
          <Text>
            {`${intl.formatMessage({
              id: 'cs_perfportal_contact_listening_call_recording_connectid',
              defaultMessage: 'Connect ID',
              description: 'Connect ID',
            })}: ${recording.connectContactId}`}
          </Text>
        </Column>
      </Box>
    </Column>
  );
};
export default SingleRecording;
